"use client";

import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Keyboard, Navigation, Scrollbar } from "swiper/modules";
import Image from "next/image";

import "swiper/css";
import "swiper/css/navigation";

function Amenitiesswiper({ amenities_data = [] }) {
  return (
    <div className="amenities-section inner-flex inner-flex-medium section-padding">
      <div className="main-container">
        <div className="flex-row alc j-c-sb">
          <div className="fourth-title-text">
            <h3 className="uppercases">Amenities</h3>
          </div>
          <div className="gallery-swiper-white-box-btn hide-mobile-only">
            <div className="swiper-button-prev amenities">
              <img src="/images/icon/swiper-left.svg" alt="" />
            </div>
            <div className="swiper-button-next amenities">
              <img src="/images/icon/swiper-right.svg" alt="" />
            </div>
          </div>
        </div>
      </div>
      <div className="relative amenities-swiper">
        <Swiper
          pagination={{
            clickable: true,
            dynamicBullets: true,
            el: ".swiper-pagination.swiper-pagination-amenities",
          }}
          spaceBetween={24}
          slidesPerView={4}
          breakpoints={{
            320: { slidesPerView: 1 },
            480: { slidesPerView: 1.5 },
            768: { slidesPerView: 2.2 },
            1024: { slidesPerView: 4 },
          }}
          keyboard={{
            enabled: true,
            onlyInViewport: true,
          }}
          navigation={{
            nextEl: ".swiper-button-next.amenities",
            prevEl: ".swiper-button-prev.amenities",
          }}
          modules={[Navigation, Scrollbar, Keyboard]}
          className="relative"
        >
          {amenities_data?.amenitiesData.map((item, index) => (
            <SwiperSlide key={index}>
              <div className="amenities-card inner-flex">
                <div
                  className="amenities-img relative"
                  style={{ aspectRatio: "1" }}
                >
                  <Image
                    src={item.image}
                    alt={item.title}
                    fill
                    className="img"
                  />
                </div>
                <div className="amenities-title section-paragraph">
                  <p className="medium-fonts uppercase text-center">
                    {item.title}
                  </p>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
}

export default Amenitiesswiper;
